import { setConfig } from '@sidegigllc/api/client'

const API_URL =
  process.env.GATSBY_GIGPRO_API_URL || 'https://core-api.qwick.com/api/'

setConfig({
  baseUrl: API_URL.replace(/\/api\/?$/, ''),
  credentials: 'omit',
})
